<template>
  <v-container>
    <jobEnviaDadosWsSoapGrid v-if="edit" @editItem="editItem" />
    <jobEnviaDadosWsSoapForm v-else :tenantUpdating="identifier" @editItem="editItem" />
  </v-container>
</template>

<script>
import jobEnviaDadosWsSoapGrid from './grid'
import jobEnviaDadosWsSoapForm from './form'

export default {
  name: 'JobEnviaDadosWsSoap',

  data: () => ({
    edit: true,
    identifier: ''
  }),

  components: {
    jobEnviaDadosWsSoapGrid,
    jobEnviaDadosWsSoapForm
  },

  methods: {
    editItem (boolean, item) {
      this.edit = boolean
      this.identifier = item?.jobIdentifier
    }
  }
}
</script>
